import { Switch as BaseSwitch } from '@base-ui/react/switch';
import styles from './Switch.module.css';

interface ISwitchProps {
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  ariaLabel: string;
  disabled?: boolean;
}

/**
 * An on/off switch — the control for a setting that is either running or
 * not, where a checkbox would read as "selected" rather than "on".
 *
 * Rendered as a real `<button>` for the same reason `ui/Checkbox` is: Base UI
 * pairs the visible control with a hidden `<input>`, and only a labelable
 * element keeps a wrapping `<label>` bound to the control the reader can see.
 */
export function Switch({ checked, onCheckedChange, ariaLabel, disabled = false }: ISwitchProps) {
  return (
    <BaseSwitch.Root
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      aria-label={ariaLabel}
      className={styles.root}
      render={<button type="button" />}
      nativeButton
    >
      <BaseSwitch.Thumb className={styles.thumb} />
    </BaseSwitch.Root>
  );
}
